/** True when the session user must not browse the dashboard. */
export function isAccountRestricted(user) {
  const status = user?.status;
  if (status === false || status === 0) return true;
  const normalized = String(status ?? "active").toLowerCase();
  return normalized === "inactive" || normalized === "suspended";
}
